'use strict';

// image rotate function
window.onscroll = function() {
  var theta = document.documentElement.scrollTop / 50 % Math.PI;
  if (document.getElementById('rotate-image')) {
    document.getElementById('rotate-image').style.transform ='rotate(' + theta + 'rad)';
  }
  if (document.getElementById('footer-rotate-image')) {
    document.getElementById('footer-rotate-image').style.transform ='rotate(' + theta + 'rad)';
  }
}
